import { useEffect, useState } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { _CostSettlement, _ImportRegistry, _single } from "../../../core/services/dataBean/EntityCatalog";
import usePaginator from "../../theme/Component/usePaginator";
import useModal, { MODAL_LG, MODAL_md, MODAL_SM } from "../../theme/Component/hooks/useModal";
import { MASK_DATE, MASK_NUMBER } from "../../theme/Component/BasicMultiSelecTable";
import { ListMenu } from "../../theme/Component/ListMenu";
import { toast } from "react-toastify";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicTable, MASK_DECIMAL } from "../../theme/Component/BasicTable";
import { Modal } from "../../theme/Component/Modal";
import { GenericItem } from "../ImportRegistry/GenericItem";
import { NationalizationPhoto } from "../OptionComponents/NationalizationPhoto/NationalizationPhoto";
import { SignList } from "../OptionComponents/SignList/SignList";
import { ImportRegistry } from "../ImportRegistry/ImportRegistry";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { InputDate } from "../../theme/Input/InputDate";
import { InputMoney } from "../../theme/Input/InputMoney";
import { DownloadFileCard } from "../../theme/Component/DownloadFileCard";
import { MultipleNotes } from "../../theme/Component/MultipleNotes";

export const CostSettlement = () => {

    const importRegistry = useDataBean(_ImportRegistry);
    const { bean, setBean, lista, setLista, instance, handleChange, isMissing, isRequired, addRequiredFields, validateForm } = useDataBean(_CostSettlement);
    const paginador = usePaginator();

    const [contract, setContract] = useState<any>({});

    const [filter, setFilter] = useState({
        Year: _single.getCurrenYear(),
        State: 1,
    })
    const [excelDocument, setExcelDocument] = useState<any>(null);
    const [excelError, setExcelError] = useState<string | null>(null);

    const modalItem = useModal("Items", MODAL_LG);
    const modalEdit = useModal("Editar", MODAL_md);
    const modalDel = useModal("Eliminar", MODAL_SM);
    const modalImgs = useModal(`Registros fotograficos de ${bean.ContractNumber}`, MODAL_LG);
    const modalSigns = useModal(`Firmas de ${bean.ContractNumber}`, MODAL_LG);
    const modalExcel = useModal(`Reporte de ${bean.ContractNumber}`, MODAL_LG);

    const head = [
        { title: 'No', property: 'IDCostSettlement', mask: MASK_NUMBER },
        { title: 'Contrato', property: 'ContractNumber' },
        { title: 'Empresa', property: 'CompanyName' },
        { title: 'Documento Transporte', property: 'TransporDocument' },
        { title: 'Fecha Documento Transporte', property: 'TrasnportDocDate', mask: MASK_DATE },
        { title: 'Fecha Contrato', property: 'ContractDate', mask: MASK_DATE },
        { title: 'Fecha Liquidación', property: 'DateLIQ', mask: MASK_DATE },
        { title: 'Tasa de Cambio', property: 'ExchangeRateLIQ', mask: MASK_DECIMAL },
        { title: 'Otros Costos', property: 'OtherCost', mask: MASK_DECIMAL },
        { title: 'Notas', property: 'ImportDeclarationNumber' },
        { title: 'Empleado', property: 'EmpleyeeName' },
    ];

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: () => { addItem() } }
    ]


    //Aqui estan los cambios

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modalEdit.open() } },
            { titulo: 'Items', icono: 'ri-list-unordered', visible: _single.canEdit(), evento: () => { modalItem.open() } },
            // { titulo: 'Registros Fotograficos', icono: 'ri-camera-line', visible: _single.canEdit(), evento: () => { modalImgs.open() } },
            { titulo: 'Descargar Reporte en Excel', icono: 'ri-file-excel-line', visible: _single.canEdit(), evento: () => { getExcel(); } },
            // { titulo: 'Firmas', icono: 'ri-quill-pen-line', visible: _single.canEdit(), evento: () => { modalSigns.open() } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalDel.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    useEffect(() => {
        addRequiredFields(["IDImportRegistry", "DateLIQ", "TransporDocument", "TrasnportDocDate"])
    }, [])

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {
        importRegistry.instance.getFormRegistryRender(_ImportRegistry.SETTLEMENT, paginador.page, 15, _single.cleanMap(filter))
            .then((resp: any) => {
                setLista(resp.List);
                paginador.setPages(resp.NumberOfPages);
            }).catch(err => { toast.error(err) })
    }

    const addItem = () => {
        setBean({ 
            IDImportRegistry: contract.IDImportRegistry,
            State: 1,
        });
        modalEdit.open();
    }

    const deleteItem = () => {
        const x = { ...bean, State: 2 };
        editaItem(x);
    };

    const getExcel = () => {
        setExcelDocument(null);
        setExcelError(null);

        importRegistry.instance.getFormatExcelByForm(bean.IDCostSettlement, _single.getAccountID(), importRegistry.instance.SETTLEMENT).then(
            (resp: any) => {
                const document = resp?.Document?.DataBeanProperties
                    ?? resp?.DataBeanProperties?.Document?.DataBeanProperties;

                if (!document?.URL) {
                    setExcelError(document?.ERR ?? "No se genero el archivo Correctamente");
                    modalExcel.open();
                    return;
                }

                setExcelDocument(document);
                modalExcel.open();
            }
        ).catch((err: any) => {
            setExcelError(err?.message ?? String(err ?? "Error desconocido al generar el archivo"));
            modalExcel.open();
        })
    }

    const editaItem = (obj: any) => {
        if (!validateForm()) {
            toast.error("Faltan Campos Obligatorios por diligenciar");
            return;
        }
        instance.updateCostSettlement({ ...obj, IDEmployee: _single.getAccountID() }).then(
            (resp: any) => {
                toast.success("Datos Guardados Correctamente");
                modalEdit.close();
                modalDel.close();
                getLista();
            }
        ).catch(err => { toast.error(err) })

    }

    return (
        <BasicPage titulo="Liquidación de costos">
            <div className="row ">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={setBean} iconButtons={iconButtonsItem} listButtons={listaBotones()} records={paginador}></BasicTable>
                    <Modal modal={modalEdit.modal} updateModal={modalEdit.setModal} eventModal={() => { editaItem(bean) }}>
                        <div className="row">
                            <div className="col-md-12">
                                <label className={`${isMissing('IDImportRegistry') ? 'has-error' : ''}`}>Contrato / Donacion {isRequired('IDImportRegistry') ? <span className="text-danger">*</span> : ''}</label>
                                <ImportRegistry label=" " editor={true} idSelector={bean.IDImportRegistry} onChange={(e) => { setBean({ ...bean, IDImportRegistry: e.IDImportRegistry }) }} />

                            </div>

                            <div className="col-md-12">
                                <label className={`${isMissing('TransporDocument') ? 'has-error' : ''}`}>Documento Transporte {isRequired('TransporDocument') ? <span className="text-danger">*</span> : ''}</label>
                                <input type="text" className="form-control" value={bean.TransporDocument} onChange={(e) => { setBean({ ...bean, TransporDocument: e.target.value }) }} />
                            </div>
                            <div className="col-md-12">
                                <label className={`${isMissing('TrasnportDocDate') ? 'has-error' : ''}`}>Fecha Documento Transporte {isRequired('TrasnportDocDate') ? <span className="text-danger">*</span> : ''}</label>
                                <InputDate name="TrasnportDocDate" value={bean.TrasnportDocDate} setDate={(e) => { setBean({ ...bean, TrasnportDocDate: e }) }} label=" " />
                            </div>

                            <div className="col-md-12">
                                <label className={`${isMissing('DateLIQ') ? 'has-error' : ''}`}>Fecha de la liquidación {isRequired('DateLIQ') ? <span className="text-danger">*</span> : ''}</label>
                                <InputDate name="DateLIQ" value={bean.DateLIQ} setDate={(e) => { setBean({ ...bean, DateLIQ: e }) }} label=" " />
                            </div>

                            <div className="col-md-12">
                                <label className={`${isMissing('ExchangeRateLIQ') ? 'has-error' : ''}`}>Tasa de cambio {isRequired('ExchangeRateLIQ') ? <span className="text-danger">*</span> : ''}</label>
                                <InputMoney _style="decimal" _value={bean.ExchangeRateLIQ} _label=" " onChange={(e) => { setBean({ ...bean, ExchangeRateLIQ: e }) }} />
                                {/* <input type="number" className="form-control" value={bean.ExchangeRateLIQ} onChange={(e) => { setBean({ ...bean, ExchangeRateLIQ: e.target.value ? parseFloat(e.target.value) : null }) }} /> */}
                            </div>

                            <div className="col-md-12">
                                <label className={`${isMissing('OtherCost') ? 'has-error' : ''}`}>Otros Costos {isRequired('OtherCost') ? <span className="text-danger">*</span> : ''}</label>
                                <InputMoney _style="decimal" _value={bean.OtherCost} _label=" " onChange={(e) => { setBean({ ...bean, OtherCost: e }) }} />
                                {/* <input type="number" className="form-control" value={bean.OtherCost} onChange={(e) => { setBean({ ...bean, OtherCost: e.target.value ? parseFloat(e.target.value) : null }) }} /> */}
                            </div>
                                <div className="col-md-12">
                                    <label className={`${isMissing('ForpoComision') ? 'has-error' : ''}`}>Comisión Forpo {isRequired('ForpoComision') ? <span className="text-danger">*</span> : ''}</label>
                                    <InputMoney _style="decimal" _value={bean.ForpoComision} _label=" " onChange={(e) => { setBean({ ...bean, ForpoComision: e }) }} />
                                </div>

                            <div className="col-md-12">
                                <label className={`${isMissing('ImportDeclarationNumber') ? 'has-error' : ''}`}>Notas {isRequired('ImportDeclarationNumber') ? <span className="text-danger">*</span> : ''}</label>
                                {/* <textarea className="form-control" value={bean.ImportDeclarationNumber} onChange={(e) => { setBean({ ...bean, ImportDeclarationNumber: e.target.value }) }} /> */}
                                <MultipleNotes
                                    label=" "
                                    notes={bean.ImportDeclarationNumber}
                                    onChange={(notes) => {
                                        setBean({ ...bean, ImportDeclarationNumber: JSON.stringify(notes) });
                                    }}
                                />
                            </div>

                        </div>
                    </Modal>

                    <ModalConfirm modal={modalDel.modal} updateModal={modalDel.setModal} eventModal={() => { deleteItem(); }}>
                        Eliminar Inventario de Mercancias {bean.IDCostSettlement} - {bean.IDCostSettlement}
                    </ModalConfirm>

                    <Modal modal={modalItem.modal} updateModal={modalItem.setModal}>
                        <GenericItem typeForm={_ImportRegistry.SETTLEMENT} formBean={bean} />
                    </Modal>

                    <Modal modal={modalImgs.modal} updateModal={modalImgs.setModal} >
                        <NationalizationPhoto isModal idFormType={bean.IDCostSettlement} formType={_ImportRegistry.SETTLEMENT} />
                    </Modal>

                    <Modal modal={modalSigns.modal} updateModal={modalSigns.setModal} >
                        <SignList isModal idFormType={bean.IDCostSettlement} formType={_ImportRegistry.SETTLEMENT} />
                    </Modal>

                    <Modal modal={modalExcel.modal} updateModal={modalExcel.setModal}>
                        <DownloadFileCard
                            file={excelDocument}
                            error={excelError}
                            fallbackName="Reporte.xlsx"
                            fileTypeLabel="Archivo Excel"
                            buttonLabel="Descargar Excel"
                            icon="ri-file-excel-2-line"
                            iconClassName="text-success"
                            buttonClassName="btn-success"
                        />
                    </Modal>

                </div>
            </div>
        </BasicPage>
    )
}
